const addPageAction = (window, name, attributes) => {
  const { newrelic } = window;
  if (newrelic) newrelic.addPageAction(name, attributes);
};

export default addPageAction;
